import { getSiteId } from '@/utils/append'

const SITEPATH = '/site/'

class RouterEnvConfig {
	set (arr) {
		if (typeof arr === 'object' && Object.keys(arr).length >= 2 && arr.id && arr.path) {
			window.$routeEnvConfig = arr
		} else {
			const routeEnvConfig = {}
			const siteId = getSiteId(SITEPATH)

			if (SITEPATH) {
				routeEnvConfig['path'] = SITEPATH
			}
			if (siteId) {
				routeEnvConfig['id'] = siteId
			}

			window.$routeEnvConfig = routeEnvConfig
		}
	}

	get () {
		const routeEnvConfig = window.$routeEnvConfig
		if (typeof window.$routeEnvConfig === 'object' && Object.keys(window.$routeEnvConfig).length >= 2) {
			return routeEnvConfig
		} else {
			return undefined
		}
	}

	clear () {
		if (typeof window.$routeEnvConfig === 'object' && Object.keys(window.$routeEnvConfig).length) {
			delete window.$routeEnvConfig
		}
	}
}

const routerEnvConfig = new RouterEnvConfig()

export default routerEnvConfig
